<div class="page-edit-profile">
    <div class="container-page-profile">
        <div class="d-flex align-items-center title-purchases mobile" *ngIf="!editAccount && !editInterest">
            <span (click)="goBack()"><i class="icon-back fa-light fa-arrow-left"></i></span>
            <p class="name-profile m-0" (click)="goBack()">Atrás</p>
        </div>
        <!-- <mat-divider></mat-divider> -->
        <!-- <div class="form-edit" [class.d-none]="!showMenu">
            <h2 class="title">Mi cuenta</h2>
            <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" fitInkBarToContent>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <i class="fa-light fa-pen tab-icon"></i> Editar perfil
                    </ng-template>
                    <ng-container *ngTemplateOutlet="accountData"></ng-container>
                </mat-tab>
                <mat-tab label="Mis intereses">
                    <ng-template mat-tab-label>
                        <i class="fa-light fa-head-side-heart tab-icon"></i> Mis intereses
                    </ng-template>
                    <app-intereses></app-intereses>
                </mat-tab>
                <mat-tab label="Suscripciones"></mat-tab>
            </mat-tab-group>




        </div> -->

        <div [ngClass]="isMobile ? 'mobile' : 'form-edit'">

            <div class="section d-flex align-items-center header-tickets-profile" *ngIf="!isMobile">
                <h2 class="title">Mis datos</h2>
            </div>
            <div class="content">
                <div>
                    <div class="content-img">
                        <div class="img-profile" (click)="file.click()">
                            <img fallimg src="{{ imgControl.value ? imgControl.value : urlImages+'/image_profile.png'}}"
                                alt="Img user" />
                            <div class="content-camera">
                                <i class="fa-light fa-camera"></i>
                            </div>
                        </div>
                        <input id="file" #file hidden type="file" accept="image/*" (change)="onFileChange($event)">
                    </div>

                    <!-- <div class="d-flex align-items-center justify-content-center"
                        *ngIf="profile?.oficial || profile?.smsValidate">
                        <div class="cont-icon-verify d-grid justify-content-center align-items-center">
                            <i class="fa-light fa-circle-check"></i>
                        </div>
                        <span class="user-verify">{{ profile?.oficial ? 'Sitio' : 'Usuario' }} verificado</span>
                    </div> -->
                </div>
                <form class="formulario-content" [formGroup]="userForm" enctype="application/x-www-form-urlencoded">
                    <!-- <mat-divider></mat-divider> -->
                    <div class="item-form container-form d-flex">
                        <i class="fa-light fa-user icon-primary"></i>
                        <div class="content-input w-100">
                            <span class="m-0 subtitle-form">Nombre</span>
                            <input id="input-nombre" class="w-100" maxlength="100" type="text" formControlName="nombre"
                                [readonly]="!isEditing('nombre')" />
                            <span class="info-input">Tu nombre será visible para los usuarios de Citylok</span>
                        </div>
                        <i class="icon-open fa-light" [ngClass]="isEditing('nombre') ? 'fa-xmark' : 'fa-pen'"
                            style="align-self: center; cursor: pointer" (click)="toggleEdit('nombre')"></i>

                        <!-- <i class="icon-open fa-light fa-floppy-disk pointer-in" style="align-self: center;"
                            *ngIf="changed" (click)="saveChanges()"></i> -->
                    </div>
                    <mat-divider></mat-divider>
                    <!-- <div class="item-form container-form d-flex">
                    <i class="fa-light fa-at icon-primary"></i>
                    <div class="content-input w-100">
                        <span class="m-0 subtitle-form">Nickname</span>
                        <input class="w-100" type="text" placeholder="" readonly>
                    </div>
                </div>
                <mat-divider></mat-divider> -->
                    <!-- <div class="item-form container-form d-flex">
                        <i class="fa-light fa-circle-info icon-primary"></i>
                        <div class="content-input w-100">
                            <span class="m-0 subtitle-form">Descripción/info</span>
                            <input #desc class="w-100" maxlength="255" type="text" formControlName="descripcion">
                            <span *ngIf="desc.value" class="info-input">Tu descripción será visible para los usuarios de
                                Citylok</span>
                        </div>
                    </div> -->
                    <div class="item-form container-form d-flex">
                        <i class="fa-light fa-phone icon-primary"></i>
                        <div class="content-input w-100">
                            <span class="m-0 subtitle-form">Teléfono</span>
                            <input id="input-movil" class="w-100" type="text" formControlName="movil"
                                [readonly]="!isEditing('movil')">
                        </div>
                        <i class="icon-open fa-light" [ngClass]="isEditing('movil') ? 'fa-xmark' : 'fa-pen'"
                            style="align-self: center; cursor: pointer" (click)="toggleEdit('movil')"></i>
                    </div>
                    <mat-divider></mat-divider>
                    <div class="item-form container-form d-flex">
                        <i class="fa-light fa-envelope icon-primary"></i>
                        <div class="content-input w-100">
                            <span class="m-0 subtitle-form">Email</span>
                            <input class="w-100" type="email" formControlName="email" readonly>
                        </div>
                    </div>
                    <!-- <mat-divider></mat-divider>
                    <div class="item-form container-form d-flex">
                    <i class="fa-light fa-calendar icon-primary"></i>
                    <div class="content-input w-100">
                        <span class="m-0 subtitle-form">Fecha de nacimiento</span>
                        <input class="w-100" type="text" formControlName="fnacimiento">
                    </div>
                </div> -->

                    <mat-divider></mat-divider>
                    <!-- <div class="item-form change-password pointer-in" (click)="openChangePassword()"
                        *ngIf="enabledPassword">
                        <i class="icon-primary fa-light fa-lock"></i>
                        <p class="m-0">Cambiar contraseña</p>
                        <i class="icon-open fa-light fa-chevron-right"></i>
                    </div> -->
                    <button class="pink-button solid w-100 pass" style="min-height: 40px;"
                        (click)="openChangePassword()">
                        <i class="icon-primary fa-light fa-lock"></i> Cambiar contraseña
                    </button>
                    <!-- <mat-divider *ngIf="!profile?.organizer"></mat-divider> -->
                </form>
                <button class="pink-button solid w-100" style="min-height: 40px;" *ngIf="isMobile"
                    (click)="deleteAccount()">
                    <i class="fa-light fa-circle-exclamation"></i> <u>Eliminar cuenta</u>
                </button>


            </div>

            <div class="d-flex justify-content-center btn-change" *ngIf="!isMobile">
                <button *ngIf="changed" class="primary-button solid w-fit"
                    style="min-height: 40px; max-width: 500px; margin-left: 20px;" (click)="saveChanges()">Guardar
                    cambios</button>
                <!-- <button *ngIf="!changed" class="disabled-btn  solid w-100"
                    style="min-height: 40px; max-width: 500px; cursor: default;">
                    Guardar cambios
                </button> -->
                <button class="pink-button solid w-100 " style="min-height: 40px;" (click)="deleteAccount()">
                    <i class="fa-light fa-circle-exclamation"></i> <u>Eliminar cuenta</u>
                </button>
            </div>
        </div>

        <div class="d-flex align-items-center mobile justify-content-center w-100" *ngIf="isMobile">

            <button *ngIf="changed" class="primary-button solid w-fit"
                style="min-height: 40px; max-width: 400px; margin-top: 10px;" (click)="saveChanges()">Guardar
                cambios</button>
        </div>

    </div>
</div>